import { AxiosResponse } from "axios";
import API from "../api";
import { AccessSettings } from "../models/access.settings";
import { AvailableTask } from "../models/available.tasks";
import { GenerateJob } from "../models/generate.job";
import { GenerateSummaryReport } from "../models/generate.summary.report";
import { PdfReport } from "../models/pdf.report";
import { Task } from "../models/task";
import BaseService from "./_base.service";
import { ReportChecklist } from "Models/report.checklist";
import { MultipleReports, Reports } from "Models/job.report";

const endpoint = "job/reports";

const JobReportService = {
  ...BaseService<AccessSettings>({ endpoint }),
  async generate(generate: GenerateJob): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/generate`, generate);
  },
  async generateMultipleReports(generate: Reports): Promise<AxiosResponse<MultipleReports[]>> {
    return await API.post(`/${endpoint}/generate`, generate, { headers: { 'Api-Version': 1 } });
  },
  async generateWorkOrderReport(generate: Reports): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${endpoint}/generate/async-work-order-report`, generate);
  },
  async summary(generate: GenerateSummaryReport): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/summary`, generate);
  },
  async availableTasks(availableTask: AvailableTask): Promise<AxiosResponse<Task[]>> {
    return await API.post(`/${endpoint}/available/tasks`, availableTask);
  },
  async getAvailableReportsByJobId(id?: number, options?: any): Promise<AxiosResponse<ReportChecklist[]>> {
    return await API.get(`/${endpoint}/available/${id}`, { params: options });
  },
};

export default JobReportService;
